'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cmsDataToModuleArray = exports.findModule = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _modules = require('./modules');

var defaultModuleMap = _interopRequireWildcard(_modules);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: move all of this into cms-modules.saga
var getModuleName = function getModuleName(moduleDef) {
  return (moduleDef.type || '').toLowerCase();
};

var findModule = exports.findModule = function findModule(moduleMap, moduleDef) {
  var moduleName = getModuleName(moduleDef);
  var module = moduleMap[moduleName] || null;
  if (!module) {
    logger.warn('module [' + moduleName + '] is unknown');
  }
  return module;
};

var moduleMapper = function moduleMapper(moduleMap, state, modules) {
  return (modules || []).map(function (moduleDef) {
    return [findModule(moduleMap, moduleDef), moduleDef];
  }).filter(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
        module = _ref2[0];

    return module;
  }).map(function (_ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        module = _ref4[0],
        moduleDef = _ref4[1];

    // This is disappearing in an upcoming PR,
    // since all modules will map themselves via
    // mapStateToProps.
    var props = module.propMapper ? module.propMapper(state, moduleDef) : moduleDef;

    var propModules = props.modules || props.items;

    return {
      Component: module,
      cmsModuleId: moduleDef.contentfulId,
      props: propModules ? (0, _extends3.default)({}, props, { modules: moduleMapper(moduleMap, state, propModules) }) : props
    };
  });
};

var cmsDataToModuleArray = exports.cmsDataToModuleArray = function cmsDataToModuleArray(state, cmsData) {
  var moduleMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModuleMap;
  return moduleMapper(moduleMap, state, cmsData.modules);
};